import { HERO_PER_PAGE } from "../../pages/ExploreV2/heroLogic";

// Hero (Trending today) layout constants, split out of ExploreHero.jsx so the
// /discover route-level Suspense fallback (DiscoverFeedSkeleton, main bundle)
// can size its hero placeholder row EXACTLY like the real hero without pulling
// ExploreHero/ExploreHeroCard out of the lazy Discover chunk (T22.516).

// Fixed hero row height.
//
// LOWERED 2026-08-02 (DL-095) from {320,340,360}: the banner card is now
// LANDSCAPE (wheel left, text right), so its natural shape is wide and short.
// Keeping the old portrait-era height would have left the text panel mostly
// empty and made the banner eat more of the bounded feed column than it needs.
// A shorter, wider band next to tall portrait grid cards is also part of what
// makes the two instantly distinguishable — which IS the requirement.
//
// QA-17 item 5 (Kelly "make trending wheels smaller" -> Gordon 2026-08-11
// "reduce rail card height ~30%"): trimmed a further ~30% from {220,240,260} to
// {154,168,182} so the trending banner reclaims feed height on the unified
// Discover page. The landscape ExploreHeroCard already absorbs a fixed row
// height (wheel `min(100%,200px)` + `maxHeight:100%`, clamped title/description),
// so every card stays exactly this tall and the row never ratchets — it just
// occupies ~70% of the vertical room it used to.
export const HERO_ROW_HEIGHT = { xs: 154, sm: 168, md: 182 };

// How many large cards fit across at each band. Three is the design; narrower
// viewports show fewer and page more, rather than shrinking cards into
// illegibility. Exported so a test asserts the mapping rather than re-deriving it.
export const HERO_PER_PAGE_BY_BAND = {
  phone: 1,
  tabletP: 2,
  tabletL: 3,
  desktop: HERO_PER_PAGE,
};

